import React from 'react';
import { Typography, Box, IconButton, Tooltip } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';

type Props = {
  isPrivate?: boolean;
  children?: React.ReactNode;
  nombreDato: string;
  onTogglePrivado: (nombreDato: string) => void;
};

const PersonalInfoHeadItem = ({ children, isPrivate, nombreDato, onTogglePrivado }: Props) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
      <Tooltip title={isPrivate ? "Marcar como público" : "Marcar como privado"}>
        <span>
          <IconButton
            size="small"
            onClick={() => onTogglePrivado(nombreDato)}
            sx={{ cursor: 'pointer' }}
          >
            {isPrivate ? <LockIcon fontSize="small" /> : <LockOpenIcon fontSize="small" />}
          </IconButton>
        </span>
      </Tooltip>
      <Box sx={{ flexGrow: 1 }}>{children}</Box>
    </Box>
  );
};

export default PersonalInfoHeadItem;
